import { useEffect, useState } from 'react';
import Link from './Link.jsx';
import { LinkIcon, GitHubIcon } from './Icons.jsx';
import { Projects, ProjectDetail } from './Projects.jsx';
import './Main.css';

function Header({ theme, onToggle }) {
  return (
    <header className="site-header">
      <Link href="/" className="wordmark">
        <img src={`${process.env.PUBLIC_URL}/contacts/face.ico`} alt="John Cho" className="pfp" />
      </Link>
      <div className="header-contact">
        <a href="mailto:johnnychox@gmail.com">johnnychox@gmail.com</a> |
        <a href="/contacts/John_Cho_CV_Final.pdf" target="_blank" rel="noreferrer">
          Resume
        </a> |
        <a href="https://www.linkedin.com/in/john-cho-7411a224b/" target="_blank" rel="noreferrer">
          LinkedIn <LinkIcon />
        </a> |
        <a href="https://github.com/chosterto" target="_blank" rel="noreferrer">
          GitHub <GitHubIcon />
        </a>
      </div>
      <ThemeToggle theme={theme} onToggle={onToggle} />
    </header>
  );
}

function ThemeToggle({ theme, onToggle }) {
  const nextTheme = theme === 'light' ? 'dark' : 'light';

  return (
    <button
      className="theme-toggle"
      type="button"
      aria-label={`Switch to ${nextTheme} mode`}
      onClick={onToggle}
    >
      <span aria-hidden="true">{theme === 'light' ? '☾' : '☀'}</span>
      {nextTheme} mode
    </button>
  );
}

function SiteFooter() {
  return (
    <footer className="site-footer">
      <span>&copy; 2026 John Cho. All rights reserved.</span>
      <span>Created with ReactJS</span>
    </footer>
  );
}

function Home() {
  return (
    <main className="home page-shell">
      <div className="intro-copy">
        <h1>Hello, I&apos;m John Cho.</h1>
        <p className="lede">
          Software engineering student and hobbyist experienced in robotics, IoT, and embedded systems.
        </p>
      </div>
      <div className="home-links">
        <Link href="/projects" className="action-button">
          <b>View my work</b> 
        </Link>
      </div>
    </main>
  );
}

function App() {
  const [path, setPath] = useState(window.location.pathname);
  const [theme, setTheme] = useState(() => localStorage.getItem('portfolio-theme') || 'dark');
  const page = path === '/projects'
    ? <Projects />
    : path.startsWith('/projects/')
      ? <ProjectDetail projectId={path.split('/').pop()} />
      : <Home />;

  useEffect(() => {
    const handlePopState = () => setPath(window.location.pathname);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem('portfolio-theme', theme);
  }, [theme]);

  function toggleTheme() {
    setTheme((currentTheme) => currentTheme === 'light' ? 'dark' : 'light');
  }

  return (
    <div className="App">
      <Header theme={theme} onToggle={toggleTheme} />
      <div className="page-transition" key={path}>
        {page}
      </div>
      <SiteFooter />
    </div>
  );
}

export default App;